export default {
  activeIntegrations: [],
};
